export default {
  activeIntegrations: [],
};
